import { Box, useBreakpointValue } from "@chakra-ui/react";
import React from "react";
import { useStudentSidebar, SIDEBAR_EXPANDED_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from "./StudentSidebarContext";

interface StudentContentLayoutProps {
  children: React.ReactNode;
}

const StudentContentLayout: React.FC<StudentContentLayoutProps> = ({ children }) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const showFooter = useBreakpointValue({ base: false, md: true });
  const { isCollapsed } = useStudentSidebar();

  const sidebarWidth = isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH;
  const contentMargin = isMobile ? 0 : `${sidebarWidth }px`;
  const footerHeight = showFooter ? 25 : 0;

  return (
    <Box
      as="main"
      mt="69px"
      ml={contentMargin}
      height={`calc(100vh - 69px - ${footerHeight}px)`}
      overflowY="auto"
      transition="margin-left 0.25s ease"
    >
      {children}
    </Box>
  );
};

export default StudentContentLayout;